(function () {
  var root = document.body;
  if (!root || !root.classList.contains('gds-product-page')) return;

  var revealEls = root.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      revealEls.forEach(function (el) { el.classList.add('in-view'); });
    }, 1500);
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  var productJsonEl = document.getElementById('gds-product-data');
  var variants = [];
  if (productJsonEl) {
    try {
      variants = (JSON.parse(productJsonEl.textContent).variants) || [];
    } catch (e) {}
  }

  var form = document.getElementById('gds-product-form');
  var idInput = form ? form.querySelector('[name="id"]') : null;
  var qtyInput = document.getElementById('gds-qty-input');
  var qtyMinus = document.getElementById('gds-qty-minus');
  var qtyPlus = document.getElementById('gds-qty-plus');

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme && theme.moneyFormat ? theme.moneyFormat : '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedOptions() {
    var opts = [];
    root.querySelectorAll('[data-gds-option]').forEach(function (group) {
      var select = group.querySelector('[data-gds-select]');
      if (select) {
        opts.push(select.value);
        return;
      }
      var active = group.querySelector('.variant-dropdown-option.active, .variant-name-chip.active, .variant-chip.active, .variant-pill.active, .variant-card.active, .bundle-option.active');
      if (active) opts.push(active.getAttribute('data-value'));
    });
    return opts;
  }

  function closeAllVariantDropdowns(except) {
    root.querySelectorAll('[data-gds-variant-dropdown]').forEach(function (dropdown) {
      if (except && dropdown === except) return;
      dropdown.classList.remove('is-open');
      var menu = dropdown.querySelector('.variant-dropdown-menu');
      var trigger = dropdown.querySelector('.variant-dropdown-trigger');
      if (menu) menu.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openVariantDropdown(dropdown) {
    closeAllVariantDropdowns(dropdown);
    dropdown.classList.add('is-open');
    var menu = dropdown.querySelector('.variant-dropdown-menu');
    var trigger = dropdown.querySelector('.variant-dropdown-trigger');
    if (menu) menu.hidden = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function syncVariantDropdownTrigger(group, optionBtn) {
    var display = group.querySelector('[data-gds-dropdown-display]');
    var priceEl = group.querySelector('[data-gds-dropdown-price]');
    var trigger = group.querySelector('.variant-dropdown-trigger');
    var optionPrice = optionBtn.querySelector('.variant-dropdown-option-price');
    if (display) display.textContent = optionBtn.getAttribute('data-value');
    if (priceEl && optionPrice) priceEl.textContent = optionPrice.textContent;
    if (trigger) {
      trigger.setAttribute('aria-label', (group.querySelector('.variant-label-name') || {}).textContent + ': ' + optionBtn.getAttribute('data-value'));
    }
  }

  function findVariant() {
    var selected = getSelectedOptions();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function findVariantByUrl() {
    try {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (!id) return null;
      return variants.find(function (v) { return String(v.id) === String(id); }) || null;
    } catch (err) {
      return null;
    }
  }

  function activateVariantOptions(variant) {
    if (!variant || !variant.options) return;
    root.querySelectorAll('[data-gds-option]').forEach(function (group, index) {
      var wanted = variant.options[index];
      if (!wanted) return;
      var btn = null;
      group.querySelectorAll('.variant-dropdown-option, .variant-name-chip, .variant-chip, .variant-pill, .variant-card, .bundle-option').forEach(function (el) {
        var match = el.getAttribute('data-value') === wanted;
        el.classList.toggle('active', match);
        if (el.classList.contains('variant-dropdown-option')) {
          el.setAttribute('aria-selected', match ? 'true' : 'false');
        }
        if (match) btn = el;
      });
      var select = group.querySelector('[data-gds-select]');
      if (select) select.value = wanted;
      var valEl = group.querySelector('[data-gds-option-value]');
      if (valEl) valEl.textContent = wanted;
      if (btn) syncVariantDropdownTrigger(group, btn);
    });
  }

  function updateVariantTag(variant) {
    var tagEl = root.querySelector('[data-gds-variant-tag]');
    if (!tagEl || !variant) return;
    var parts = variant.options.filter(function (o) { return o && o !== 'Default Title'; });
    tagEl.textContent = parts.length ? parts.join(' · ') : '';
  }

  function setActiveThumbBySrc(src) {
    if (!src) return;
    var normalized = src.split('?')[0];
    root.querySelectorAll('.gallery-rail-v-btn, .gallery-thumb-btn').forEach(function (btn) {
      var btnSrc = (btn.dataset.img || '').split('?')[0];
      var match = btnSrc && normalized.indexOf(btnSrc.split('/').pop().replace(/_\d+x/, '')) > -1;
      if (!match && btnSrc) {
        match = normalized.indexOf(btnSrc.split('/').slice(-1)[0].split('_')[0]) > -1;
      }
      btn.classList.toggle('active', match);
    });
  }

  function formatWeight(grams, unitHint) {
    var unit = (unitHint || (document.querySelector('[data-gds-specs]') || {}).getAttribute('data-weight-unit') || 'kg').toLowerCase();
    var value = Number(grams) || 0;
    if (value <= 0) return '';
    // Storefront product JSON weight is grams.
    if (unit === 'kg') {
      var kg = value / 1000;
      var rounded = Math.round(kg * 1000) / 1000;
      return String(rounded) + ' kg';
    }
    if (unit === 'lb' || unit === 'lbs') {
      var lb = value / 453.59237;
      return (Math.round(lb * 1000) / 1000) + ' lb';
    }
    if (unit === 'oz') {
      var oz = value / 28.349523125;
      return (Math.round(oz * 100) / 100) + ' oz';
    }
    return value + ' g';
  }

  function setSpecRow(key, text) {
    root.querySelectorAll('[data-gds-spec-row="' + key + '"]').forEach(function (row) {
      var cell = row.querySelector('[data-gds-spec-' + key + ']');
      if (cell) cell.textContent = text || '';
      if (text) row.removeAttribute('hidden');
      else row.setAttribute('hidden', 'hidden');
    });
  }

  function syncVariantUrl(variant) {
    if (!variant || !variant.id || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url.pathname + '?' + url.searchParams.toString() + url.hash);
    } catch (err) {}
  }

  function updatePriceUI(variant) {
    if (!variant) return;
    var nowEls = root.querySelectorAll('[data-gds-price]');
    var wasEls = root.querySelectorAll('[data-gds-compare-price]');
    var saveBadge = root.querySelector('[data-gds-save-badge]');
    var addBtns = root.querySelectorAll('[data-gds-add-label]');
    var stickyAdd = root.querySelector('[data-gds-sticky-add]');
    var buyNowBtn = root.querySelector('[data-gds-buy-now]');
    var price = formatMoney(variant.price);
    nowEls.forEach(function (el) { el.textContent = price; });
    if (variant.compare_at_price > variant.price) {
      var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      wasEls.forEach(function (el) {
        el.textContent = formatMoney(variant.compare_at_price);
        el.hidden = false;
      });
      if (saveBadge) {
        saveBadge.textContent = 'Save ' + pct + '%';
        saveBadge.hidden = false;
      }
    } else {
      wasEls.forEach(function (el) { el.hidden = true; });
      if (saveBadge) saveBadge.hidden = true;
    }
    addBtns.forEach(function (el) {
      el.textContent = variant.available ? '+ Add' : 'Sold Out';
      el.disabled = !variant.available;
      el.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
    });
    if (stickyAdd) {
      stickyAdd.disabled = !variant.available;
      stickyAdd.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      stickyAdd.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    if (buyNowBtn) {
      buyNowBtn.disabled = !variant.available;
      buyNowBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
    }
    var avail = root.querySelector('[data-gds-availability]');
    if (avail) {
      avail.classList.toggle('in-stock', variant.available);
      avail.classList.toggle('out-stock', !variant.available);
      var availText = avail.querySelector('[data-gds-avail-text]');
      if (availText) {
        availText.textContent = variant.available
          ? avail.getAttribute('data-in-stock-text') || 'In stock — ready to ship'
          : 'Currently unavailable';
      }
    }
    if (idInput) idInput.value = variant.id;

    // HI-08: keep purchase-area SKU + Specifications table bound to the selected variant.
    var skuValue = variant.sku || '';
    root.querySelectorAll('[data-gds-sku]').forEach(function (skuEl) {
      var valueEl = skuEl.querySelector('[data-gds-sku-value]');
      if (valueEl) valueEl.textContent = skuValue;
      else skuEl.textContent = skuValue ? ('SKU: ' + skuValue) : '';
      if (skuValue) skuEl.removeAttribute('hidden');
      else skuEl.setAttribute('hidden', 'hidden');
    });
    setSpecRow('sku', skuValue);
    setSpecRow('barcode', variant.barcode || '');
    setSpecRow('weight', formatWeight(variant.weight));

    var htgiStatus = document.getElementById('gds-htgi-status');
    var htgiRootEl = document.getElementById('gds-how-to-get-it');
    if (htgiRootEl) {
      htgiRootEl.setAttribute('data-product-available', variant.available ? 'true' : 'false');
    }
    if (htgiStatus) {
      htgiStatus.textContent = variant.available
        ? htgiStatus.getAttribute('data-available-text') || 'Available'
        : htgiStatus.getAttribute('data-unavailable-text') || 'Unavailable';
      htgiStatus.classList.toggle('is-available', variant.available);
      htgiStatus.classList.toggle('is-unavailable', !variant.available);
    }
    updateVariantTag(variant);
    syncVariantUrl(variant);
    if (variant.featured_image && variant.featured_image.src) {
      var mainImg = document.getElementById('gds-gallery-main-img');
      if (mainImg) {
        var src = variant.featured_image.src;
        mainImg.src = src.indexOf('?') > -1 ? src : src.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_900x$1$3');
        setActiveThumbBySrc(mainImg.src);
      }
    }
  }

  function selectVariantOption(group, btn) {
    if (btn.disabled) return;
    group.querySelectorAll('.variant-dropdown-option, .variant-name-chip, .variant-chip, .variant-pill, .variant-card, .bundle-option').forEach(function (b) {
      b.classList.remove('active');
      if (b.classList.contains('variant-dropdown-option')) {
        b.setAttribute('aria-selected', 'false');
      }
    });
    btn.classList.add('active');
    if (btn.classList.contains('variant-dropdown-option')) {
      btn.setAttribute('aria-selected', 'true');
      syncVariantDropdownTrigger(group, btn);
    }
    var valEl = group.querySelector('[data-gds-option-value]');
    if (valEl) valEl.textContent = btn.getAttribute('data-value');
    var variant = findVariant();
    if (variant) updatePriceUI(variant);
  }

  function bindVariantControls(group) {
    var dropdown = group.querySelector('[data-gds-variant-dropdown]');
    if (dropdown) {
      var trigger = dropdown.querySelector('.variant-dropdown-trigger');
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (dropdown.classList.contains('is-open')) {
            closeAllVariantDropdowns();
          } else {
            openVariantDropdown(dropdown);
          }
        });
      }
      dropdown.querySelectorAll('.variant-dropdown-option').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          selectVariantOption(group, btn);
          closeAllVariantDropdowns();
        });
      });
    }

    group.querySelectorAll('.variant-name-chip, .variant-chip, .variant-pill, .variant-card, .bundle-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectVariantOption(group, btn);
      });
    });
    var select = group.querySelector('[data-gds-select]');
    if (select) {
      select.addEventListener('change', function () {
        var valEl = group.querySelector('[data-gds-option-value]');
        if (valEl) valEl.textContent = select.value;
        var variant = findVariant();
        if (variant) updatePriceUI(variant);
      });
    }
  }

  root.querySelectorAll('[data-gds-option]').forEach(bindVariantControls);

  document.addEventListener('click', function () {
    closeAllVariantDropdowns();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllVariantDropdowns();
  });

  var initialVariant = findVariantByUrl() || findVariant();
  if (initialVariant) {
    activateVariantOptions(initialVariant);
    updatePriceUI(initialVariant);
  }

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = Math.min(10, parseInt(qtyInput.value, 10) + 1);
    });
  }

  var galleryMain = document.getElementById('gds-gallery-main');
  var galleryMainImg = document.getElementById('gds-gallery-main-img');
  var galleryCounter = document.getElementById('gds-gallery-counter');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.gallery-rail-v-btn, .gallery-thumb-btn'));
  var mediaTotal = thumbs.length;
  var currentIndex = 1;

  function setGalleryImage(src, index) {
    if (galleryMainImg && src) galleryMainImg.src = src;
    if (index) currentIndex = parseInt(index, 10);
    if (galleryCounter && mediaTotal) galleryCounter.textContent = currentIndex + ' / ' + mediaTotal;
    if (galleryMain) galleryMain.classList.remove('zoomed');
    thumbs.forEach(function (t, i) {
      t.classList.toggle('active', index ? parseInt(index, 10) === i + 1 : t.dataset.img === src);
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      setGalleryImage(thumb.dataset.img, thumb.dataset.index);
    });
  });

  var prevBtn = document.getElementById('gds-gallery-prev');
  var nextBtn = document.getElementById('gds-gallery-next');
  if (prevBtn && mediaTotal > 1) {
    prevBtn.addEventListener('click', function () {
      var idx = currentIndex <= 1 ? mediaTotal : currentIndex - 1;
      var t = thumbs[idx - 1];
      if (t) setGalleryImage(t.dataset.img, idx);
    });
  }
  if (nextBtn && mediaTotal > 1) {
    nextBtn.addEventListener('click', function () {
      var idx = currentIndex >= mediaTotal ? 1 : currentIndex + 1;
      var t = thumbs[idx - 1];
      if (t) setGalleryImage(t.dataset.img, idx);
    });
  }

  if (galleryMain) {
    var allowGalleryZoom = window.matchMedia('(min-width: 721px) and (hover: hover)').matches;
    if (allowGalleryZoom) {
      galleryMain.addEventListener('click', function (e) {
        if (e.target.closest('.gallery-nav') || e.target.closest('.gallery-actions')) return;
        galleryMain.classList.toggle('zoomed');
      });
    }
  }

  root.querySelectorAll('.pdp-accordions .faq-item').forEach(function (item) {
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = !item.classList.contains('open');
      item.classList.toggle('open', isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      var chev = btn.querySelector('.chev');
      if (chev) chev.textContent = isOpen ? '\u00d7' : '+';
    });
  });

  var tabsRoot = root.querySelector('[data-pdp-tabs]');
  if (tabsRoot) {
    var tabBtns = tabsRoot.querySelectorAll('.pdp-tab-btn');
    var tabPanels = tabsRoot.querySelectorAll('.pdp-tab-panel');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tab');
        tabBtns.forEach(function (b) {
          b.classList.toggle('active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        tabPanels.forEach(function (panel) {
          var on = panel.getAttribute('data-panel') === id;
          panel.classList.toggle('active', on);
          if (on) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      });
    });
  }

  var buyNowBtn = document.getElementById('gds-buy-now');
  if (buyNowBtn && form) {
    buyNowBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (buyNowBtn.disabled) return;
      var fd = new FormData(form);
      fetch((window.theme && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.href = '/checkout';
      });
    });
  }

  var stickyCart = document.getElementById('gds-sticky-cart');
  var ctaAnchor = document.getElementById('gds-pdp-cta-anchor');
  if (stickyCart && ctaAnchor && 'IntersectionObserver' in window) {
    root.classList.add('has-sticky-cart');
    var cartObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting;
        stickyCart.classList.toggle('show', show);
        stickyCart.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    cartObserver.observe(ctaAnchor);
  }

  var stickyAdd = document.querySelector('[data-gds-sticky-add]');
  if (stickyAdd && form) {
    stickyAdd.addEventListener('click', function (e) {
      e.preventDefault();
      if (stickyAdd.disabled) return;
      var submit = form.querySelector('[name="add"]');
      if (submit) submit.click();
    });
  }

  function initFbt(fbtForm) {
    if (!fbtForm || fbtForm.dataset.gdsFbtInit) return;
    fbtForm.dataset.gdsFbtInit = '1';
    var fbtChecks = fbtForm.querySelectorAll('input[type="checkbox"][data-fbt-variant]');
    var fbtTotal = fbtForm.querySelector('[data-fbt-total]');
    var mainPrice = parseInt(fbtForm.getAttribute('data-main-price') || '0', 10);
    function updateFbtTotal() {
      var total = mainPrice;
      var count = 1;
      fbtChecks.forEach(function (cb) {
        if (cb.checked) {
          total += parseInt(cb.getAttribute('data-price'), 10) || 0;
          count++;
        }
      });
      if (fbtTotal) fbtTotal.textContent = formatMoney(total);
      var countEl = fbtForm.querySelector('[data-fbt-count]');
      if (countEl) countEl.textContent = count;
    }
    fbtChecks.forEach(function (cb) { cb.addEventListener('change', updateFbtTotal); });
    fbtForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [];
      var mainId = fbtForm.getAttribute('data-main-variant');
      if (mainId) items.push({ id: parseInt(mainId, 10), quantity: 1 });
      fbtChecks.forEach(function (cb) {
        if (cb.checked) items.push({ id: parseInt(cb.getAttribute('data-fbt-variant'), 10), quantity: 1 });
      });
      if (!items.length) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () { window.location.href = '/cart'; });
    });
  }
  window.gdsInitFbt = initFbt;
  initFbt(document.getElementById('gds-fbt-form'));

  (function initHowToGetIt() {
    var htgiRoot = document.getElementById('gds-how-to-get-it');
    if (!htgiRoot) return;

    var zipToggle = document.getElementById('gds-zip-toggle');
    var zipInput = document.getElementById('gds-zip-input');
    var zipDisplay = document.getElementById('gds-zip-display');
    var zipSubmit = document.getElementById('gds-zip-submit');
    var statusEl = document.getElementById('gds-htgi-status');
    var placeEl = document.getElementById('gds-htgi-place');
    var dateEl = document.getElementById('gds-htgi-date');
    var zipModal = document.getElementById('gds-zip-modal');
    var modalError = document.getElementById('gds-zip-modal-error');
    var modalResult = document.getElementById('gds-zip-modal-result');
    var storageKey = 'gds_delivery_zip';
    var placeKey = 'gds_delivery_place';
    var confirmedKey = 'gds_delivery_zip_confirmed';
    var country = (htgiRoot.getAttribute('data-country') || 'US').toUpperCase();
    var minDays = parseInt(htgiRoot.getAttribute('data-min-days') || '3', 10) || 3;
    var maxDays = parseInt(htgiRoot.getAttribute('data-max-days') || '15', 10) || 15;
    if (maxDays < minDays) maxDays = minDays;
    var busy = false;
    var confirmedZip = '';
    var EMPTY_LABEL = 'Enter ZIP / postal code';

    function productAvailable() {
      return htgiRoot.getAttribute('data-product-available') === 'true';
    }

    function showZip(val) {
      if (zipDisplay) zipDisplay.textContent = val || EMPTY_LABEL;
    }

    function setPlace(text) {
      if (!placeEl) return;
      if (text) {
        placeEl.textContent = text;
        placeEl.hidden = false;
      } else {
        placeEl.textContent = '';
        placeEl.hidden = true;
      }
    }

    function setStatus(kind, message) {
      if (!statusEl) return;
      statusEl.classList.remove('is-available', 'is-unavailable', 'is-checking');
      if (kind) statusEl.classList.add(kind);
      if (message) statusEl.textContent = message;
    }

    function addBusinessDays(from, days) {
      var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
      var left = days;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) left -= 1;
      }
      return d;
    }

    function formatEstimateDate(date) {
      try {
        return date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      } catch (err) {
        var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return days[date.getDay()] + ', ' + months[date.getMonth()] + ' ' + date.getDate();
      }
    }

    function updateEstimateDate(locationReady) {
      if (!dateEl) return;
      if (!locationReady) {
        dateEl.textContent = 'Enter location';
        dateEl.classList.add('is-unavailable');
        return;
      }
      if (!productAvailable()) {
        dateEl.textContent = 'Sold out';
        dateEl.classList.add('is-unavailable');
        return;
      }
      var start = addBusinessDays(new Date(), minDays);
      var end = addBusinessDays(new Date(), maxDays);
      dateEl.textContent = minDays === maxDays
        ? formatEstimateDate(end)
        : formatEstimateDate(start) + ' – ' + formatEstimateDate(end);
      dateEl.classList.remove('is-unavailable');
    }

    function normalizeZip(raw) {
      return String(raw || '').replace(/\s+/g, ' ').trim().toUpperCase();
    }

    /* HI-07 / ME-14: US ZIP + CA postal only (store ships to both markets). */
    function detectPostalRegion(zip) {
      if (/^\d{5}(-\d{4})?$/.test(zip)) return 'US';
      if (/^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/.test(zip)) return 'CA';
      return '';
    }

    function isValidFormat(zip) {
      return !!detectPostalRegion(zip);
    }

    function lookupPath(zip) {
      var region = detectPostalRegion(zip) || country;
      if (region === 'CA') {
        return 'https://api.zippopotam.us/ca/' + encodeURIComponent(zip.replace(/\s+/g, ''));
      }
      return 'https://api.zippopotam.us/us/' + encodeURIComponent(zip.slice(0, 5));
    }

    function formatDisplayZip(zip) {
      var region = detectPostalRegion(zip);
      if (region === 'CA') {
        var compact = zip.replace(/\s+/g, '');
        return compact.replace(/^(.{3})(.{3})$/, '$1 $2');
      }
      return zip.slice(0, 5);
    }

    function stockStatusLabel() {
      if (productAvailable()) {
        return (statusEl && statusEl.getAttribute('data-available-text')) || 'Available';
      }
      return (statusEl && statusEl.getAttribute('data-soldout-text')) || 'Sold out';
    }

    /**
     * @param {'empty'|'invalid'|'ok'} mode
     * @param {string} placeLabel
     */
    function applyAvailability(mode, placeLabel) {
      if (mode === 'empty') {
        setStatus(productAvailable() ? 'is-available' : 'is-unavailable', stockStatusLabel());
        setPlace('');
        updateEstimateDate(false);
        return;
      }
      if (mode === 'invalid') {
        setStatus('is-unavailable', (statusEl && statusEl.getAttribute('data-invalid-text')) || 'Invalid ZIP / postal code');
        setPlace('');
        updateEstimateDate(false);
        return;
      }
      setPlace(placeLabel || '');
      if (productAvailable()) {
        setStatus('is-available', stockStatusLabel());
        updateEstimateDate(true);
      } else {
        setStatus('is-unavailable', stockStatusLabel());
        updateEstimateDate(true);
      }
    }

    var submitLabel = zipSubmit ? zipSubmit.textContent : '';

    function setBusy(on) {
      busy = on;
      if (zipSubmit) {
        zipSubmit.disabled = on;
        zipSubmit.textContent = on ? 'Checking…' : submitLabel;
      }
      if (zipInput) zipInput.disabled = on;
      if (on) {
        setStatus('is-checking', (statusEl && statusEl.getAttribute('data-checking-text')) || 'Checking…');
      }
    }

    function saveZip(zip, placeLabel) {
      try {
        localStorage.setItem(storageKey, zip);
        localStorage.setItem(confirmedKey, '1');
        if (placeLabel) localStorage.setItem(placeKey, placeLabel);
        else localStorage.removeItem(placeKey);
      } catch (err) {}
    }

    function setModalError(message) {
      if (!modalError) return;
      if (message) {
        modalError.textContent = message;
        modalError.hidden = false;
      } else {
        modalError.textContent = '';
        modalError.hidden = true;
      }
    }

    function setModalResult(kind, message) {
      if (!modalResult) return;
      modalResult.classList.remove('is-available', 'is-unavailable');
      if (!message) {
        modalResult.textContent = '';
        modalResult.hidden = true;
        return;
      }
      if (kind) modalResult.classList.add(kind);
      modalResult.textContent = message;
      modalResult.hidden = false;
    }

    var modalCloseTimer = null;

    function openZipModal() {
      if (!zipModal) return;
      if (modalCloseTimer) { clearTimeout(modalCloseTimer); modalCloseTimer = null; }
      setModalError('');
      setModalResult('', '');
      zipModal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (zipInput) {
        zipInput.disabled = false;
        if (!zipInput.value && confirmedZip) zipInput.value = confirmedZip;
        window.requestAnimationFrame(function () {
          zipInput.focus();
          if (zipInput.value) zipInput.select();
        });
      }
    }

    function closeZipModal() {
      if (!zipModal || zipModal.hidden) return;
      if (modalCloseTimer) { clearTimeout(modalCloseTimer); modalCloseTimer = null; }
      zipModal.hidden = true;
      document.body.style.overflow = '';
      if (zipToggle) zipToggle.focus();
    }

    function finishModalSuccess(placeLabel, displayZip) {
      var where = (placeLabel ? placeLabel + ' ' : '') + displayZip;
      var label = productAvailable()
        ? 'Delivery estimate available for ' + where + ' (Canada & USA). Final rates at checkout.'
        : 'Location verified for ' + where + '. This item is sold out, so a delivery date can’t be estimated.';
      setModalResult(productAvailable() ? 'is-available' : 'is-unavailable', label);
      modalCloseTimer = setTimeout(closeZipModal, productAvailable() ? 1200 : 2200);
    }

    function updateZip(rawZip) {
      var zip = normalizeZip(rawZip);
      if (!zip) {
        setModalError('Enter a US ZIP or Canadian postal code.');
        if (zipInput) zipInput.focus();
        return Promise.resolve();
      }

      if (!isValidFormat(zip)) {
        if (zipInput) {
          zipInput.setAttribute('aria-invalid', 'true');
          zipInput.focus();
        }
        setModalError('Enter a valid US ZIP (e.g. 98101) or Canadian postal code (e.g. V6B 1A1). We ship to Canada and the USA only.');
        setModalResult('', '');
        return Promise.resolve();
      }

      if (zipInput) zipInput.removeAttribute('aria-invalid');
      setModalError('');
      setBusy(true);

      return fetch(lookupPath(zip), { method: 'GET', mode: 'cors' })
        .then(function (res) {
          if (!res.ok) throw new Error('not found');
          return res.json();
        })
        .then(function (data) {
          var place = '';
          if (data && data.places && data.places[0]) {
            var p = data.places[0];
            place = [p['place name'], p['state abbreviation'] || p.state].filter(Boolean).join(', ');
          }
          var displayZip = formatDisplayZip(zip);
          confirmedZip = displayZip;
          if (zipInput) zipInput.value = displayZip;
          showZip(displayZip);
          saveZip(displayZip, place);
          applyAvailability('ok', place);
          setBusy(false);
          finishModalSuccess(place, displayZip);
        })
        .catch(function () {
          setBusy(false);
          var region = detectPostalRegion(zip);
          // Zippopotam’s CA dataset is often unavailable; accept well-formed
          // Canadian postal codes so CA customers aren’t blocked (HI-07).
          if (region === 'CA') {
            var displayZip = formatDisplayZip(zip);
            confirmedZip = displayZip;
            if (zipInput) zipInput.value = displayZip;
            showZip(displayZip);
            saveZip(displayZip, '');
            applyAvailability('ok', '');
            finishModalSuccess('', displayZip);
            return;
          }
          setModalError('We couldn’t verify that ZIP. Check the code — we only estimate delivery for Canada and the USA.');
          setModalResult('', '');
          if (zipInput) {
            zipInput.setAttribute('aria-invalid', 'true');
            zipInput.focus();
          }
        });
    }

    var savedZip = '';
    var savedPlace = '';
    var wasConfirmed = false;
    try {
      savedZip = localStorage.getItem(storageKey) || '';
      savedPlace = localStorage.getItem(placeKey) || '';
      wasConfirmed = localStorage.getItem(confirmedKey) === '1';
    } catch (e) {}

    // ME-14: never use a theme default ZIP. Only restore a customer-confirmed code.
    if (wasConfirmed && savedZip && isValidFormat(normalizeZip(savedZip))) {
      confirmedZip = formatDisplayZip(normalizeZip(savedZip));
      showZip(confirmedZip);
      if (zipInput) zipInput.value = confirmedZip;
      if (savedPlace) setPlace(savedPlace);
      applyAvailability('ok', savedPlace);
    } else {
      try {
        localStorage.removeItem(storageKey);
        localStorage.removeItem(placeKey);
        localStorage.removeItem(confirmedKey);
      } catch (e2) {}
      confirmedZip = '';
      showZip('');
      if (zipInput) zipInput.value = '';
      applyAvailability('empty', '');
    }

    if (zipToggle) {
      zipToggle.addEventListener('click', openZipModal);
    }

    if (zipModal) {
      zipModal.querySelectorAll('[data-zip-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeZipModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !zipModal.hidden) closeZipModal();
      });
    }

    if (zipSubmit && zipInput) {
      zipSubmit.addEventListener('click', function () {
        if (busy) return;
        updateZip(zipInput.value);
      });
      zipInput.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (busy) return;
        updateZip(zipInput.value);
      });
      zipInput.addEventListener('input', function () {
        setModalError('');
        zipInput.removeAttribute('aria-invalid');
      });
    }

    // Refresh estimate when variant availability flips (keeps location; updates stock/date).
    var obs = new MutationObserver(function () {
      if (confirmedZip && isValidFormat(normalizeZip(confirmedZip))) {
        applyAvailability('ok', (placeEl && !placeEl.hidden && placeEl.textContent) || '');
      } else {
        applyAvailability('empty', '');
      }
    });
    obs.observe(htgiRoot, { attributes: true, attributeFilter: ['data-product-available'] });
  })();

  // Wishlist controls removed until a real wishlist app exists (HI-01).
  // Also strip any leftover buttons from sticky page_cache HTML.
  try {
    document.querySelectorAll('#gds-wish-btn, #gds-purchase-wish, .btn-purchase-wish, button[aria-label="Add to wishlist"]').forEach(function (el) {
      el.remove();
    });
  } catch (e) {}
})();
